<ng-container *ngIf="ionic; else default">
  <ion-item
    mode="md"
    lines="none"
    color="transparent"
    class="item-no-padding"
    [disabled]="isDisabled"
  >
    <ion-select
      [interface]="interface"
      toggleIcon="chevron-down-outline"
      expandedIcon="chevron-up-outline"
      [mode]="mode"
      [fill]="fill"
      [placeholder]="isFilled ? '' : label || placeholder"
      [value]="value"
      [label]="label"
      [disabled]="isDisabled"
      [compareWith]="compareWith"
      [cancelText]="cancelText"
      [okText]="okText"
      class="ionic-select"
      [class.ionic-select--filled]="isFilled"
      [class.ionic-select--error]="hasError"
      [class.ionic-select--disabled]="isDisabled"
      [class.ionic-select--focused]="isFocused"
      label-placement="floating"
      (ionChange)="onSelectionChange($event)"
      (ionFocus)="onFocus()"
      (ionBlur)="onBlur()"
    >
      <ng-container *ngIf="showLeftIcon">
        <ng-container
          *ngIf="leftIconName | checkIcon : variantIcon | async as config"
        >
          <ion-icon
            slot="start"
            [name]="config.name"
            [src]="config.src"
            class="icon-start"
          ></ion-icon>
        </ng-container>
      </ng-container>

      <ng-container *ngFor="let option of options; trackBy: trackByOptionValue">
        <ion-select-option [value]="option.value">
          {{ option.label }}
        </ion-select-option>
      </ng-container>
    </ion-select>
  </ion-item>
</ng-container>

<ng-template #default>
  <ion-item
    class="sf-getm"
    [class.sf-getm--filled]="isFilled"
    [class.sf-getm--error]="hasError"
    [class.sf-getm--disabled]="isDisabled"
    [class.sf-getm--focused]="isFocused"
    lines="none"
    (click)="openSelect($event)"
    [style.cursor]="isDisabled ? 'not-allowed' : 'pointer'"
  >
    <div class="sf-getm__content">
      <span *ngIf="label && isFilled" class="sf-getm__floating-label">
        {{ label }}
      </span>

      <div class="sf-getm__left">
        <app-icon-getm
          *ngIf="showLeftIcon"
          [name]="leftIconName"
          [variant]="variantIcon"
          size="m"
          class="sf-getm__icon sf-getm__icon--left"
          aria-hidden="true"
        >
        </app-icon-getm>

        <ion-select
          #selectRef
          interface="popover"
          [placeholder]="isFilled ? '' : label || placeholder"
          [disabled]="isDisabled"
          [compareWith]="compareWith"
          [value]="value"
          [cancelText]="cancelText"
          [okText]="okText"
          (ionChange)="onSelectionChange($event)"
          (ionFocus)="onFocus()"
          (ionBlur)="onBlur()"
          class="sf-getm__select"
          mode="ios"
          [attr.aria-label]="label || placeholder"
          [attr.aria-describedby]="supportingText || error ? 'support' : null"
        >
          <ion-select-option
            *ngFor="let option of options; trackBy: trackByOptionValue"
            [value]="option.value"
          >
            {{ option.label }}
          </ion-select-option>
        </ion-select>
      </div>

      <app-icon-getm
        name="chevron-down"
        variant="outline"
        size="m"
        class="sf-getm__icon sf-getm__icon--right"
        aria-hidden="true"
      >
      </app-icon-getm>
    </div>
  </ion-item>

  <ion-text
    *ngIf="supportingText || error"
    class="sf-getm__support"
    role="status"
    [attr.aria-live]="hasError ? 'assertive' : 'polite'"
    [color]="hasError ? 'danger' : undefined"
  >
    <ion-icon
      name="information-circle-outline"
      class="sf-getm__support-icon"
      aria-hidden="true"
    ></ion-icon>
    <span class="sf-getm__support-text">{{ error || supportingText }}</span>
  </ion-text>
</ng-template>
